<template>
  <div class="container uk-flex uk-flex-center">
    <div class="main">
      <img
        class="img-not-found uk-flex uk-flex-wrap"
        src="../assets/img/img-page-not-found.png"
        alt="IBD"
      >
      <br>
      <div class="title uk-text-center">
        <h2>Pagina no encontrada!!!</h2>
        <h4>Lo siento, esta pagina no es valida, vuelva a la pagina principal</h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.img-not-found{
  width: 40%;
  margin: auto;
  max-width: 600px;
}
.title h2{
  font-weight: 600;
  color: #002c3f;
}

.title h4{
  margin: 0px;
  color: #002c3f;

}
.container{
  height: 443px;
}

.main{
  margin: auto;
}

</style>
